// extracted by mini-css-extract-plugin
export default {"container":"SettingLocationTenants_container__toY8C","list":"SettingLocationTenants_list__Qk2V7"};